import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['output'];

  print({ target }) {
    this.outputTarget.textContent = target.value;
  }
}
